// import { useEffect, useState } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { HandCoins, Wallet, PiggyBank, Plus, Pencil } from 'lucide-react';

// import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
// import Tabs from '../../../components/Tabs/Tabs';
// import Table, { StatusPill, TABLE_THEME } from '../../../components/Table/Table';

// import usePayrollEntity from '../../../utils/usePayrollEntity';
// import { fmtRs, fmtMoney } from '../../../utils/payrollFormat';
// import { toIsoDate } from '../../../utils/dateFormat';
// import { getEmployeeList } from '../../../action/Employee';
// import { savePayrollEntity } from '../../../action/Payroll';
// import payRollService from '../../../services/PayrollService';
// import AddLoanDialog from '../../../components/Loan/AddLoanDialog';
// import AddLoanInstallmentDialog from '../../../components/Loan/AddLoanInstallmentDialog';
// import { toast } from 'react-toastify';
// import useToast from '../../../utils/useToast';
// import Toast from '../../../components/Toast/Toast';

// const FIELD = `${TABLE_THEME.fieldBase} ${TABLE_THEME.fieldFocus}`;
// const LABEL = TABLE_THEME.fieldLabel;
// const ICON = { size: 15 };

// const TABLE_PROPS = {
//   search: true,
//   searchLabel: 'Search',
//   pageSize: 10,
//   scrollClassName: '',
// };

// const statusColumn = {
//   key: 'status',
//   label: 'Status',
//   align: 'center',
//   render: (r) => <StatusPill label={r.status} />,
// };

// /* ── Loan Management ─────────────────────────────────────────────────────── */
// const LoanManagementTab = () => {
//   const dispatch = useDispatch();

//   const [open, setOpen] = useState(false);
//   const [editingLoan, setEditingLoan] = useState(null);

//   const employees = useSelector((state) => state.employee.list);

//   const { list, loading } = usePayrollEntity('loanManagement');
//   const { list: periods } = usePayrollEntity('payrollPeriods');

//   const { toast, showToast, hideToast } = useToast();

//   useEffect(() => {
//     dispatch(getEmployeeList());
//   }, [dispatch]);

//   const getNextLoanNumber = () => {
//     const maxNumber = list.reduce((max, loan) => {
//       const match = String(loan.loanNo || "").match(/^LN-(\d+)/);

//       if (!match) {
//         return max;
//       }

//       return Math.max(max, Number(match[1]));
//     }, 0);

//     return `LN-${String(maxNumber + 1).padStart(4, "0")}`;
//   }

//   const createLoanInstallments = async (loanId, loan) => {
//     const numberOfInstallments = Number(loan.noOfInstallments || 0);
//     const installmentAmount = Number(loan.installmentAmount || 0);

//     if (!loanId || numberOfInstallments <= 0 || installmentAmount <= 0) {
//       return;
//     }

//     for (let installmentNo = 1; installmentNo <= numberOfInstallments; installmentNo++) {
//       await dispatch(
//         savePayrollEntity("loanInstallments", {
//           loanId: Number(loanId),
//           installmentNo,
//           payrollPeriodId: Number(loan.startPeriodId),
//           dueDate: loan.dueDate,
//           installmentAmount,
//           paidAmount: 0,
//           balanceAmount: installmentAmount,
//           status: 1,
//           payrollId: null,
//           remarks: loan.remarks || "",
//         })
//       )
//     }
//   }

//   // const handleSave = async (form) => {
//   //   await dispatch(savePayrollEntity('loanManagement', form, !!editingLoan));
//   //   setOpen(false);
//   //   setEditingLoan(null);
//   // };

//   const handleSave = async (form) => {
//     const isEditing = !!editingLoan;

//     try {
//       const loanData = {
//         ...form,
//         loanNo: isEditing ? form.loanNo : getNextLoanNumber(),
//         isActive: true,
//       };

//       const loanId = await dispatch(savePayrollEntity('loanManagement', loanData, isEditing));

//       // Only automatically create loan installments when creating a new loan
//       if (!isEditing) {
//         await createLoanInstallments(loanId, loanData);
//       }

//       setOpen(false);
//       setEditingLoan(null);

//       showToast(isEditing ? "Loan updated successfully." : "Loan and installments created successfully.", 'success');
//     } catch (error) {
//       console.error("Failed to save loan: ", error);

//       showToast(error?.message || "Failed to save loan.", "error");
//     }
//   }

//   return (
//     <>
//       <Table
//         {...TABLE_PROPS}
//         title="Loan Management"
//         loading={loading}
//         rows={list}
//         rowKey="id"
//         searchKeys={['empNo', 'name', 'loanType']}
//         searchPlaceholder="Search loans..."
//         emptyMessage="No loans found"
//         onAdd={{
//           label: 'New Loan',
//           icon: <Plus {...ICON} />,
//           onClick: () => {
//             setEditingLoan(null);
//             setOpen(true);
//           },
//         }}
//         columns={[
//           { key: 'loanNo', label: 'Loan No', className: 'font-semibold text-gray-900' },
//           { key: 'loanDate', label: 'Loan Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.loanDate) },
//           {
//             key: 'name',
//             label: 'Employee',
//             grow: true,
//             className: 'text-gray-700',
//             render: (r) => {
//               const emp = employees.find(
//                 (e) => String(e.HED_EMPLOYEE_ID) === String(r.employeeId)
//               );
//               return emp ? `${emp.HED_REPORT_NAME} (${emp.HED_SERVICE_NO})` : '-';
//             },
//           },
//           { key: 'loanType', label: 'Loan Type', className: 'text-gray-600' },
//           { key: 'amount', label: 'Loan Amount (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.amount) },
//           { key: 'installments', label: 'Installments', align: 'right', className: 'text-gray-600' },
//           { key: 'balance', label: 'Balance (Rs)', align: 'right', className: 'text-gray-700', render: (r) => fmtMoney(r.balance) },
//           statusColumn,
//           {
//             key: 'edit',
//             label: 'Actions',
//             align: 'center',
//             sortable: false,
//             render: (r) => (
//               <button
//                 type="button"
//                 title="Edit Loan"
//                 onClick={() => {
//                   setEditingLoan(r);
//                   setOpen(true);
//                 }}
//                 className="inline-flex items-center justify-center w-7 h-7 rounded-md text-gray-500
//                   hover:text-primary-700 hover:bg-primary-50 transition-colors"
//               >
//                 <Pencil size={14} />
//               </button>
//             ),
//           },
//         ]}
//       />

//       <AddLoanDialog
//         open={open}
//         onClose={() => {
//           setOpen(false);
//           setEditingLoan(null);
//         }}
//         nextLoanNo={getNextLoanNumber()}
//         onSave={handleSave}
//         employees={employees}
//         payrollPeriods={periods}
//         loading={loading}
//         initialData={editingLoan}
//       />

//       <Toast 
//         message={toast?.message}
//         type={toast?.type}
//         onClose={hideToast}
//       />
//     </>
//   );
// };

// /* ── Loan Installments ───────────────────────────────────────────────────── */
// const LoanInstallmentsTab = () => {
//   const dispatch = useDispatch();

//   const employees = useSelector((state) => state.employee.list);
//   const { list: periods } = usePayrollEntity('payrollPeriods');

//   const [employeeId, setEmployeeId] = useState('');
//   const [loanId, setLoanId] = useState('');
//   const [loans, setLoans] = useState([]);
//   const [installments, setInstallments] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [open, setOpen] = useState(false);

//   // Map the raw API response from GetInstallmentsByLoan
//   const mapLoanInstallment = (item) => ({
//     id: item.HLI_INSTALLMENT_ID,
//     loanId: item.HLI_LOAN_ID,
//     installmentNo: item.HLI_INSTALLMENT_NO,
//     payrollPeriodId: item.HLI_PAYROLL_PERIOD_ID,
//     dueDate: item.HLI_DUE_DATE.split(' ')[0],
//     installmentAmount: item.HLI_INSTALLMENT_AMOUNT,
//     paidAmount: item.HLI_PAID_AMOUNT,
//     balanceAmount: item.HLI_BALANCE_AMOUNT,
//     status: item.HLI_STATUS === '1' ? 'Active' : 'Inactive',
//     payrollId: item.HLI_PAYROLL_ID,
//     createdBy: item.HLI_CREATED_BY,
//     createdDate: item.HLI_CREATED_DATE,
//     updatedBy: item.HLI_UPDATED_BY,
//     updatedDate: item.HLI_UPDATED_DATE,
//     isActive: item.HLI_IS_ACTIVE,
//     remarks: item.HLI_REMARKS,
//   });

//   const getPayrollPeriodName = (periodId) => {
//     const period = periods.find((p) => String(p.id) === String(periodId));
//     return period ? `${period.code} - ${period.name}` : '-';
//   };

//   const loadLoans = async () => {
//     setLoading(true);
//     try {
//       const response = await payRollService.GetLoansByEmployee(employeeId);
//       setLoans(response.data.ResultSet || []);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loadInstallments = async () => {
//     setLoading(true);
//     try {
//       const response = await payRollService.GetLoanInstallments(loanId);
//       const list = (response.data.ResultSet || []).map(mapLoanInstallment);
//       setInstallments(list);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     dispatch(getEmployeeList());
//   }, [dispatch]);

//   useEffect(() => {
//     if (!employeeId) {
//       setLoans([]);
//       setLoanId('');
//       return;
//     }
//     loadLoans();
//   }, [employeeId]);

//   useEffect(() => {
//     if (!loanId) {
//       setInstallments([]);
//       return;
//     }
//     loadInstallments();
//   }, [loanId]);

//   const handleSave = async (form) => {
//     await dispatch(savePayrollEntity('loanInstallments', form));
//     setOpen(false);
//     loadInstallments();
//   };

//   return (
//     <>
//       <Table
//         {...TABLE_PROPS}
//         search={false}
//         title="Loan Installments"
//         loading={loading}
//         rows={installments}
//         rowKey="id"
//         emptyMessage={
//           !employeeId
//             ? 'Select an employee to view installments.'
//             : !loanId
//             ? 'Select a loan to view installments.'
//             : 'No installments found'
//         }
//         // onAdd={{
//         //   label: 'New Installment',
//         //   icon: <Plus {...ICON} />,
//         //   onClick: () => {
//         //     if (!loanId) return;
//         //     setOpen(true);
//         //   },
//         // }}
//         toolbarExtra={
//           <div className="flex flex-wrap items-end gap-3">
//             <div className="w-[300px] max-w-full">
//               <span className={LABEL}>Employee</span>
//               <select
//                 value={employeeId}
//                 onChange={(e) => {
//                   setEmployeeId(e.target.value);
//                   setLoanId('');
//                 }}
//                 className={`${FIELD} w-full`}
//               >
//                 <option value="">Select Employee</option>
//                 {employees.map((emp) => (
//                   <option key={emp.HED_EMPLOYEE_ID} value={emp.HED_EMPLOYEE_ID}>
//                     {emp.HED_SERVICE_NO} - {emp.HED_REPORT_NAME}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="w-[300px] max-w-full">
//               <span className={LABEL}>Loan</span>
//               <select
//                 value={loanId}
//                 disabled={!employeeId || loading}
//                 onChange={(e) => setLoanId(e.target.value)}
//                 className={`${FIELD} w-full disabled:bg-gray-50 disabled:text-gray-400 disabled:cursor-not-allowed`}
//               >
//                 <option value="">
//                   {!employeeId
//                     ? 'Select Employee First'
//                     : loading
//                     ? 'Loading Loans...'
//                     : loans.length === 0
//                     ? 'No Loans Found'
//                     : 'Select Loan'}
//                 </option>
//                 {loans.map((loan) => (
//                   <option key={loan.HLM_LOAN_ID} value={loan.HLM_LOAN_ID}>
//                     {loan.HLM_LOAN_NO} - {loan.HLM_LOAN_TYPE}
//                   </option>
//                 ))}
//               </select>
//             </div>
//           </div>
//         }
//         columns={[
//           { key: 'installmentNo', label: 'Installment', align: 'center', className: 'font-semibold text-gray-900 tabular-nums' },
//           {
//             key: 'payrollPeriodId',
//             label: 'Payroll Period',
//             grow: true,
//             className: 'text-gray-700',
//             render: (r) => getPayrollPeriodName(r.payrollPeriodId),
//           },
//           { key: 'installmentAmount', label: 'Installment Amount (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.installmentAmount) },
//           { key: 'paidAmount', label: 'Paid Amount (Rs)', align: 'right', className: 'text-gray-600', render: (r) => fmtMoney(r.paidAmount) },
//           { key: 'balanceAmount', label: 'Balance Amount (Rs)', align: 'right', className: 'text-gray-700', render: (r) => fmtMoney(r.balanceAmount) },
//           { key: 'dueDate', label: 'Due Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.dueDate) },
//           statusColumn,
//         ]}
//       />

//       <AddLoanInstallmentDialog
//         open={open}
//         onClose={() => setOpen(false)}
//         onSave={handleSave}
//         payrollPeriods={periods}
//         loan={loans.find((l) => String(l.HLM_LOAN_ID) === String(loanId))}
//         existingInstallments={installments}
//       />
//     </>
//   );
// };

// /* ── Salary Advances ─────────────────────────────────────────────────────── */
// const SalaryAdvancesTab = () => {
//   const { list, loading } = usePayrollEntity('salaryAdvances');
//   return (
//     <Table
//       {...TABLE_PROPS}
//       title="Salary Advances"
//       loading={loading}
//       rows={list}
//       rowKey="id"
//       searchKeys={['empNo', 'name']}
//       searchPlaceholder="Search salary advances..."
//       emptyMessage="No salary advances found"
//       onAdd={{ label: 'New Advance', icon: <Plus {...ICON} /> }}
//       columns={[
//         { key: 'name', label: 'Employee', grow: true, className: 'font-semibold text-gray-900', render: (r) => `${r.name} (${r.empNo})` },
//         { key: 'amount', label: 'Amount (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.amount) },
//         { key: 'requestDate', label: 'Request Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.requestDate) },
//         { key: 'recoveryMonth', label: 'Recovery Month', align: 'center', className: 'text-gray-600' },
//         statusColumn,
//       ]}
//     />
//   );
// };

// /* ── Page ────────────────────────────────────────────────────────────────── */
// const LoansAdvances = () => {
//   const tabs = [
//     { key: 'loans', label: 'Loan Management', icon: <HandCoins {...ICON} />, content: <LoanManagementTab /> },
//     { key: 'installments', label: 'Loan Installments', icon: <Wallet {...ICON} />, content: <LoanInstallmentsTab /> },
//     // { key: 'advances', label: 'Salary Advances', icon: <PiggyBank {...ICON} />, content: <SalaryAdvancesTab /> },
//   ];

//   return (
//     <div className="p-6 space-y-4">
//       <Breadcrumb
//         trail={['Payroll', 'Loans & Advances']}
//         title="Loans & Advances"
//         subtitle="Manage staff loans, installment schedules and salary advances."
//       />
//       <Tabs tabs={tabs} defaultTab="loans" />
//     </div>
//   );
// };

// export default LoansAdvances;




import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { HandCoins, Wallet, PiggyBank, Plus, Pencil } from 'lucide-react';

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb';
import Tabs from '../../../components/Tabs/Tabs';
import Table, { StatusPill, TABLE_THEME } from '../../../components/Table/Table';

import usePayrollEntity from '../../../utils/usePayrollEntity';
import { fmtRs, fmtMoney } from '../../../utils/payrollFormat';
import { toIsoDate } from '../../../utils/dateFormat';
import { fetchAllEmployees } from '../../../store/slices/employeeSlice';
import { fetchLoanList, savePayrollEntity } from '../../../store/slices/payrollSlice';
import payRollService from '../../../services/PayrollService';
import AddLoanDialog from '../../../components/Loan/AddLoanDialog';
import AddLoanInstallmentDialog from '../../../components/Loan/AddLoanInstallmentDialog';
import { toast } from 'react-toastify';
import useToast from '../../../utils/useToast';
import Toast from '../../../components/Toast/Toast';
import { useConfirm } from '../../../utils/ConfirmContext';
import { getLoggedInServiceNo } from '../../../utils/masterDataUtils';

const FIELD = `${TABLE_THEME.fieldBase} ${TABLE_THEME.fieldFocus}`;
const LABEL = TABLE_THEME.fieldLabel;
const ICON = { size: 15 };

const TABLE_PROPS = {
  search: true,
  searchLabel: 'Search',
  pageSize: 10,
  scrollClassName: '',
};

const statusColumn = {
  key: 'status',
  label: 'Status',
  align: 'center',
  render: (r) => <StatusPill label={r.status} />,
};

/* ── Loan Management ─────────────────────────────────────────────────────── */
const LoanManagementTab = () => {
  const dispatch = useDispatch();

  const [open, setOpen] = useState(false);
  const [editingLoan, setEditingLoan] = useState(null);
  const [loanStatus, setLoanStatus] = useState("approved");
  const [nextLoanNo, setNextLoanNo] = useState("");

  const employees = useSelector((state) => state.employees.employees);

  const loanEntity = useSelector((state) => state.payroll.entities.loanManagement || {
    list: [],
    loading: false,
  })
  const { list, loading } = loanEntity;

  const { list: periods } = usePayrollEntity('payrollPeriods');

  const { toast, showToast, hideToast } = useToast();

  const searchableLoans = useMemo(() => {
    return list.map((loan) => {
      const emp = employees.find(
        (e) => String(e.HED_EMPLOYEE_ID) === String(loan.employeeId)
      );
      return {
        ...loan,
        name: emp ? emp.HED_REPORT_NAME : "",
        empNo: emp ? emp.HED_SERVICE_NO : "",
      };
    });
  }, [list, employees]);

  useEffect(() => {
    dispatch(fetchAllEmployees());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchLoanList(loanStatus === "approved" ? 1 : 0));
  }, [dispatch, loanStatus]);

  useEffect(() => {
    fetchNextLoanNumber();
  }, []);

  // const getNextLoanNumber = () => {
  //   const maxNumber = list.reduce((max, loan) => {
  //     const match = String(loan.loanNo || "").match(/^LN-(\d+)/);

  //     if (!match) {
  //       return max;
  //     }

  //     return Math.max(max, Number(match[1]));
  //   }, 0);

  //   return `LN-${String(maxNumber + 1).padStart(4, "0")}`;
  // }

  const fetchNextLoanNumber = async () => {
    try {
      const [approvedRes, notApprovedRes] = await Promise.all([
        payRollService.GetLoanList(1),
        payRollService.GetLoanList(0),
      ]);

      const allLoans = [
        ...(approvedRes?.data?.ResultSet || []),
        ...(notApprovedRes?.data?.ResultSet || []),
      ];

      const maxNumber = allLoans.reduce((max, loan) => {
        const loanNo = loan.HLM_LOAN_NO || loan.loanNo || "";
        const match = String(loanNo).match(/^LN-(\d+)/);
        return match ? Math.max(max, Number(match[1])) : max;
      }, 0);

      const generated = `LN-${String(maxNumber + 1).padStart(4, "0")}`;
      setNextLoanNo(generated);
      return generated;
    } catch (error) {
      console.error("Failed to fetch next loan number: ", error);
      return "LN-0001";
    }
  }

  const addMonths = (date, months) => {
    const originalDay = date.getDate();

    const result = new Date(date);
    result.setDate(1);
    result.setMonth(result.getMonth() + months);

    const lastDayOfMonth = new Date(
      result.getFullYear(),
      result.getMonth() + 1,
      0
    ).getDate();

    result.setDate(Math.min(originalDay, lastDayOfMonth));

    return result;
  }

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`
  }

  const createLoanInstallments = async (loanId, loan) => {
    const numberOfInstallments = Number(loan.noOfInstallments || 0);
    const installmentAmount = Number(loan.installmentAmount || 0);

    if (!loanId || numberOfInstallments <= 0 || installmentAmount <= 0) {
      return;
    }

    const firstDueDate = new Date(loan.dueDate);

    for (let installmentNo = 1; installmentNo <= numberOfInstallments; installmentNo++) {
      const installmentDueDate = formatDate(addMonths(firstDueDate, installmentNo - 1));

      await dispatch(
        savePayrollEntity("loanInstallments", {
          loanId: Number(loanId),
          installmentNo,
          payrollPeriodId: Number(loan.startPeriodId),
          dueDate: installmentDueDate,
          installmentAmount,
          paidAmount: 0,
          balanceAmount: installmentAmount,
          status: 1,
          payrollId: null,
          remarks: loan.remarks || "",
        })
      )
    }
  }

  // const handleSave = async (form) => {
  //   await dispatch(savePayrollEntity('loanManagement', form, !!editingLoan));
  //   setOpen(false);
  //   setEditingLoan(null);
  // };

  const handleSave = async (form) => {
    const isEditing = !!editingLoan;

    try {
      const loanNo = isEditing ? form.loanNo : (nextLoanNo || await fetchNextLoanNumber())

      const isLoanActive = isEditing 
        ? Boolean(form.isActive ===  true || form.isActive === 1 || form.isActive === "1" || editingLoan?.isActive === true || editingLoan?.isActive === 1 || loanStatus === "approved") 
        : false;


      const loanData = {
        ...form,
        loanNo,
        isActive: isLoanActive,
      };

      const loanId = await dispatch(savePayrollEntity('loanManagement', loanData, isEditing));

      // Only automatically create loan installments when creating a new loan
      if (!isEditing) {
        await createLoanInstallments(loanId, loanData);
      }

      setOpen(false);
      setEditingLoan(null);

      showToast(isEditing ? "Loan updated successfully." : "Loan and installments created successfully.", 'success');

      dispatch(fetchLoanList(loanStatus === "approved" ? 1 : 0))
      fetchNextLoanNumber();
    } catch (error) {
      console.error("Failed to save loan: ", error);

      showToast(error?.message || "Failed to save loan.", "error");
    }
  }

  return (
    <>
      <Table
        {...TABLE_PROPS}
        title="Loan Management"
        loading={loading}
        rows={searchableLoans}
        rowKey="id"
        searchKeys={['empNo', 'name', 'loanType', 'loanNo']}
        searchPlaceholder="Search loans..."
        emptyMessage="No loans found"
        onAdd={{
          label: 'New Loan',
          icon: <Plus {...ICON} />,
          onClick: async () => {
            setEditingLoan(null);
            await fetchNextLoanNumber();
            setOpen(true);
          },
        }}
        toolbarExtra={
          <div className='flex flex-wrap items-end gap-3'>
            <div className='w-[220px] max-w-full'>
              <span className={LABEL}>Loan Status</span>

              <select
                value={loanStatus}
                onChange={(e) => setLoanStatus(e.target.value)}
                className={`${FIELD} w-full`}
              >  
                <option value="approved">Approved</option>
                <option value="notApproved">Not Approved</option>
              </select>
            </div>
          </div>
        }
        columns={[
          { key: 'loanNo', label: 'Loan No', className: 'font-semibold text-gray-900' },
          { key: 'loanDate', label: 'Loan Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.loanDate) },
          {
            key: 'name',
            label: 'Employee',
            grow: true,
            className: 'text-gray-700',
            render: (r) => {
              const emp = employees.find(
                (e) => String(e.HED_EMPLOYEE_ID) === String(r.employeeId)
              );
              return emp ? `${emp.HED_REPORT_NAME} (${emp.HED_SERVICE_NO})` : '-';
            },
          },
          { key: 'loanType', label: 'Loan Type', className: 'text-gray-600' },
          { key: 'amount', label: 'Loan Amount (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.amount) },
          { key: 'installments', label: 'Installments', align: 'right', className: 'text-gray-600' },
          { key: 'balance', label: 'Balance (Rs)', align: 'right', className: 'text-gray-700', render: (r) => fmtMoney(r.balance) },
          statusColumn,
          {
            key: 'edit',
            label: 'Actions',
            align: 'center',
            sortable: false,
            render: (r) => (
              <button
                type="button"
                title="Edit Loan"
                onClick={() => {
                  setEditingLoan(r);
                  setOpen(true);
                }}
                className="inline-flex items-center justify-center w-7 h-7 rounded-md text-gray-500
                  hover:text-primary-700 hover:bg-primary-50 transition-colors"
              >
                <Pencil size={14} />
              </button>
            ),
          },
        ]}
      />

      <AddLoanDialog
        open={open}
        onClose={() => {
          setOpen(false);
          setEditingLoan(null);
        }}
        nextLoanNo={nextLoanNo}
        onSave={handleSave}
        employees={employees}
        payrollPeriods={periods}
        loading={loading}
        initialData={editingLoan} 
      />

      <Toast 
        message={toast?.message}
        type={toast?.type}
        onClose={hideToast}
      />
    </>
  );
};

/* ── Loan Installments ───────────────────────────────────────────────────── */
const LoanInstallmentsTab = () => {
  const dispatch = useDispatch();

  const employees = useSelector((state) => state.employees.employees);
  const { list: periods } = usePayrollEntity('payrollPeriods');

  const [employeeId, setEmployeeId] = useState('');
  const [loanId, setLoanId] = useState('');
  const [loans, setLoans] = useState([]);
  const [installments, setInstallments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);

  // Map the raw API response from GetInstallmentsByLoan
  const mapLoanInstallment = (item) => ({
    id: item.HLI_INSTALLMENT_ID,
    loanId: item.HLI_LOAN_ID,
    installmentNo: item.HLI_INSTALLMENT_NO,
    // payrollPeriodId: item.HLI_PAYROLL_PERIOD_ID,
    payrollPeriodId: null,
    dueDate: item.HLI_DUE_DATE.split(' ')[0],
    installmentAmount: item.HLI_INSTALLMENT_AMOUNT,
    paidAmount: item.HLI_PAID_AMOUNT,
    balanceAmount: item.HLI_BALANCE_AMOUNT,
    status: item.HLI_STATUS === '1' ? 'Active' : 'Inactive',
    payrollId: item.HLI_PAYROLL_ID,
    createdBy: item.HLI_CREATED_BY,
    createdDate: item.HLI_CREATED_DATE,
    updatedBy: item.HLI_UPDATED_BY,
    updatedDate: item.HLI_UPDATED_DATE,
    isActive: item.HLI_IS_ACTIVE,
    remarks: item.HLI_REMARKS,
  });

  const getPayrollPeriodName = (periodId) => {
    const period = periods.find((p) => String(p.id) === String(periodId));
    return period ? `${period.code} - ${period.name}` : '-';
  };

  const loadLoans = async () => {
    setLoading(true);
    try {
      const response = await payRollService.GetLoansByEmployee(employeeId);
      setLoans(response.data.ResultSet || []);
    } finally {
      setLoading(false);
    }
  };

  const loadInstallments = async () => {
    setLoading(true);
    try {
      const response = await payRollService.GetLoanInstallments(loanId);
      const list = (response.data.ResultSet || []).map(mapLoanInstallment);
      setInstallments(list);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    dispatch(fetchAllEmployees());
  }, [dispatch]);

  useEffect(() => {
    if (!employeeId) {
      setLoans([]);
      setLoanId('');
      return;
    }
    loadLoans();
  }, [employeeId]);

  useEffect(() => {
    if (!loanId) {
      setInstallments([]);
      return;
    }
    loadInstallments();
  }, [loanId]);

  const handleSave = async (form) => {
    await dispatch(savePayrollEntity('loanInstallments', form));
    setOpen(false);
    loadInstallments();
  };

  const resolveInstallmentName = (dueDate) => {
    const [year, month, day] = dueDate.split("-");

    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

    const monthName = months[parseInt(month, 10) - 1] ?? "-";

    return `${year} ${monthName}`
  }

  return (
    <>
      <Table
        {...TABLE_PROPS}
        search={false}
        title="Loan Installments"
        loading={loading}
        rows={installments}
        rowKey="id"
        emptyMessage={
          !employeeId
            ? 'Select an employee to view installments.'
            : !loanId
            ? 'Select a loan to view installments.'
            : 'No installments found'
        }
        // onAdd={{
        //   label: 'New Installment',
        //   icon: <Plus {...ICON} />,
        //   onClick: () => {
        //     if (!loanId) return;
        //     setOpen(true);
        //   },
        // }}
        toolbarExtra={
          <div className="flex flex-wrap items-end gap-3">
            <div className="w-[300px] max-w-full">
              <span className={LABEL}>Employee</span>
              <select
                value={employeeId}
                onChange={(e) => {
                  setEmployeeId(e.target.value);
                  setLoanId('');
                }}
                className={`${FIELD} w-full`}
              >
                <option value="">Select Employee</option>
                {employees.map((emp) => (
                  <option key={emp.HED_EMPLOYEE_ID} value={emp.HED_EMPLOYEE_ID}>
                    {emp.HED_SERVICE_NO} - {emp.HED_REPORT_NAME}
                  </option>
                ))}
              </select>
            </div>

            <div className="w-[300px] max-w-full">
              <span className={LABEL}>Loan</span>
              <select
                value={loanId}
                disabled={!employeeId || loading}
                onChange={(e) => setLoanId(e.target.value)}
                className={`${FIELD} w-full disabled:bg-gray-50 disabled:text-gray-400 disabled:cursor-not-allowed`}
              >
                <option value="">
                  {!employeeId
                    ? 'Select Employee First'
                    : loading
                    ? 'Loading Loans...'
                    : loans.length === 0
                    ? 'No Loans Found'
                    : 'Select Loan'}
                </option>
                {loans.map((loan) => (
                  <option key={loan.HLM_LOAN_ID} value={loan.HLM_LOAN_ID}>
                    {loan.HLM_LOAN_NO} - {loan.HLM_LOAN_TYPE}
                  </option>
                ))}
              </select>
            </div>
          </div>
        }
        columns={[
          { key: 'installmentNo', label: 'Installment', align: 'center', className: 'font-semibold text-gray-900 tabular-nums' },
          {
            key: 'payrollPeriodId',
            label: 'Payroll Period',
            grow: true,
            className: 'text-gray-700',
            // render: (r) => getPayrollPeriodName(r.payrollPeriodId),
            render: (r) => resolveInstallmentName(toIsoDate(r.dueDate)),
          },
          { key: 'installmentAmount', label: 'Installment Amount (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.installmentAmount) },
          { key: 'paidAmount', label: 'Paid Amount (Rs)', align: 'right', className: 'text-gray-600', render: (r) => fmtMoney(r.paidAmount) },
          { key: 'balanceAmount', label: 'Balance Amount (Rs)', align: 'right', className: 'text-gray-700', render: (r) => fmtMoney(r.balanceAmount) },
          { key: 'dueDate', label: 'Due Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.dueDate) },
          statusColumn,
        ]}
      />

      <AddLoanInstallmentDialog
        open={open}
        onClose={() => setOpen(false)}
        onSave={handleSave}
        payrollPeriods={periods}
        loan={loans.find((l) => String(l.HLM_LOAN_ID) === String(loanId))}
        existingInstallments={installments}
      />
    </>
  );
};

const LoanApprovalTab = () => {
  const dispatch = useDispatch();
  const confirm = useConfirm();

  const employees = useSelector((state) => state.employees.employees);

  const loanEntity = useSelector(
    (state) => state.payroll.entities.loanManagement || {
      list: [],
      loading: false,
    }
  );

  const { list, loading } = loanEntity;

  const { toast, showToast, hideToast } = useToast();

  useEffect(() => {
    dispatch(fetchAllEmployees());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchLoanList(0));
  }, [dispatch]);

  const handleApprove = async (loan) => {
    const confirmed = await confirm({
      title: `Approve this loan?`,
      message: `Are you sure you want to approve loan ${loan.loanNo}?`,
      confirmLabel: "Approve",
      cancelLabel: "Cancel",
  });

    if (!confirmed) {
      return;
    }

    try {
      const today = new Date().toISOString().split("T")[0];
      const approvedBy = getLoggedInServiceNo() || "ADMIN";

      await dispatch(
        savePayrollEntity(
          'loanManagement',
          {
            ...loan,
            isActive: true,
            // status: "A",
            approvedDate: today,
            approvedBy: approvedBy,
          },
          true
        )
      );

      showToast("Loan approved successfully.", "success");

      // Refresh pending loans
      dispatch(fetchLoanList(0));
    } catch (error) {
      console.error("Failed to approve loan:", error);

      showToast(
        error?.message || "Failed to approve loan.",
        "error"
      );
    }
  };

  return (
    <>
      <Table
        {...TABLE_PROPS}
        title="Loan Approval"
        loading={loading}
        rows={list}
        rowKey="id"
        searchKeys={['empNo', 'name', 'loanType']}
        searchPlaceholder="Search loans..."
        emptyMessage="No loans pending approval"
        columns={[
          {
            key: 'loanNo',
            label: 'Loan No',
            className: 'font-semibold text-gray-900',
          },
          {
            key: 'loanDate',
            label: 'Loan Date',
            align: 'center',
            className: 'text-gray-600 tabular-nums',
            render: (r) => toIsoDate(r.loanDate),
          },
          {
            key: 'name',
            label: 'Employee',
            grow: true,
            className: 'text-gray-700',
            render: (r) => {
              const emp = employees.find(
                (e) =>
                  String(e.HED_EMPLOYEE_ID) ===
                  String(r.employeeId)
              );

              return emp
                ? `${emp.HED_REPORT_NAME} (${emp.HED_SERVICE_NO})`
                : '-';
            },
          },
          {
            key: 'loanType',
            label: 'Loan Type',
            className: 'text-gray-600',
          },
          {
            key: 'amount',
            label: 'Loan Amount (Rs)',
            align: 'right',
            className: 'font-semibold text-gray-900',
            render: (r) => fmtMoney(r.amount),
          },
          {
            key: 'installments',
            label: 'Installments',
            align: 'right',
            className: 'text-gray-600',
          },
          {
            key: 'balance',
            label: 'Balance (Rs)',
            align: 'right',
            className: 'text-gray-700',
            render: (r) => fmtMoney(r.balance),
          },
          statusColumn,
          {
            key: 'approve',
            label: 'Actions',
            align: 'center',
            sortable: false,
            render: (r) => (
              <button
                type="button"
                onClick={() => handleApprove(r)}
                className="inline-flex items-center justify-center px-3 py-1.5 rounded-md
                  text-sm font-medium text-white bg-primary-600
                  hover:bg-primary-700 transition-colors"
              >
                Approve Loan
              </button>
            ),
          },
        ]}
      />

      <Toast
        message={toast?.message}
        type={toast?.type}
        onClose={hideToast}
      />
    </>
  );
};

/* ── Salary Advances ─────────────────────────────────────────────────────── */
const SalaryAdvancesTab = () => {
  const { list, loading } = usePayrollEntity('salaryAdvances');
  return (
    <Table
      {...TABLE_PROPS}
      title="Salary Advances"
      loading={loading}
      rows={list}
      rowKey="id"
      searchKeys={['empNo', 'name']}
      searchPlaceholder="Search salary advances..."
      emptyMessage="No salary advances found"
      onAdd={{ label: 'New Advance', icon: <Plus {...ICON} /> }}
      columns={[
        { key: 'name', label: 'Employee', grow: true, className: 'font-semibold text-gray-900', render: (r) => `${r.name} (${r.empNo})` },
        { key: 'amount', label: 'Amount (Rs)', align: 'right', className: 'font-semibold text-gray-900', render: (r) => fmtMoney(r.amount) },
        { key: 'requestDate', label: 'Request Date', align: 'center', className: 'text-gray-600 tabular-nums', render: (r) => toIsoDate(r.requestDate) },
        { key: 'recoveryMonth', label: 'Recovery Month', align: 'center', className: 'text-gray-600' },
        statusColumn,
      ]}
    />
  );
};

/* ── Page ────────────────────────────────────────────────────────────────── */
const LoansAdvances = () => {
  const tabs = [
    { key: 'loans', label: 'Loan Management', icon: <HandCoins {...ICON} />, content: <LoanManagementTab /> },
    { key: 'installments', label: 'Loan Installments', icon: <Wallet {...ICON} />, content: <LoanInstallmentsTab /> },
    { key: 'approval', label: 'Loan Approval', icon: <HandCoins {...ICON} />, content: <LoanApprovalTab /> },
    // { key: 'advances', label: 'Salary Advances', icon: <PiggyBank {...ICON} />, content: <SalaryAdvancesTab /> },
  ];

  return (
    <div className="p-6 space-y-4">
      <Breadcrumb
        trail={['Payroll', 'Loans & Advances']}
        title="Loans & Advances"
        subtitle="Manage staff loans, installment schedules and salary advances."
      />
      <Tabs tabs={tabs} defaultTab="loans" />
    </div>
  );
};

export default LoansAdvances;